import { render, staticRenderFns } from "./PosterDashboard.vue?vue&type=template&id=d4e1c5e8"
import script from "./PosterDashboard.vue?vue&type=script&lang=js"
export * from "./PosterDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports